export const SET_USER_INFO = 'setUserInfo';
export const SET_LEARNING_STATISTICS = 'setLearningStatistics';
